import React, { useCallback } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './Button';

export function FinalCTA() {
  const handleStartGame = useCallback(() => {
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Focus on display name input after scroll
    setTimeout(() => {
      const input = document.getElementById('displayName') as HTMLInputElement;
      input?.focus();
    }, 400);
  }, []);

  return (
    <section className="py-20 bg-gray-50 px-4 sm:px-6 lg:px-8 text-center">
      <motion.div
        initial={{
          opacity: 0,
          scale: 0.95,
        }}
        whileInView={{
          opacity: 1,
          scale: 1,
        }}
        viewport={{
          once: true,
        }}
        transition={{
          duration: 0.5,
        }}
        className="max-w-3xl mx-auto"
      >
        <h2 className="text-2xl sm:text-3xl font-bold text-black mb-6">
          Ready to play with your crew?
        </h2>

        <div className="flex flex-col items-center gap-3">
          <Button onClick={handleStartGame} className="group min-w-[180px]">
            Start a Game
            <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Button>
          <p className="text-gray-500 text-xs font-medium">
            Free • No signup required
          </p>
        </div>
      </motion.div>
    </section>
  );
}
